// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_gu-3";
export var flatBottomCorners = "_gu-5";
export var productImage = "_gu-0";
export var quantityContainer = "_gu-2";
export var quantityHeader = "_gu-6";
export var tooltip = "_gu-1";
export var wrapAndEllipsesOverflow = "_gu-4";